export default {
    year: 0,
    make: {
        slug: '',
        name: '',
    },
    model: {
        id: 0,
        slug: '',
        name: '',
    },
    bodyStyle: {
        slug: '',
        name: '',
    },
    multimedia: {
        pictureDisclaimer: '',
        exterior: {
            side: '',
            rear: '',
            front: '',
        },
    },
    tagline: '',
    description: '',
};



// WEBPACK FOOTER //
// ./src/models/BaseVehicle.js